// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"18a4aa92","455":"3463b848","488":"86b200df","551":"a48e601c","977":"9f75bb80"}[chunkId] + ".chunk.js";
};